import React, { useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { collection, query, where, getDocs, getDoc, doc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import Loading from "../Loading";
import styleClasses from "./css/MyPage.module.scss";

function MusicardSelector({ onSelect }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [musicards, setMusicards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { memberID } = useParams();
  const uid = auth.currentUser ? auth.currentUser.uid : null;

  // 검색 버튼을 누르면 실행
  const handleSearch = async () => {
    if (!uid) {
      navigate("/login");
      return;
    }
    setIsLoading(true);
    try {
      // 활성화된 뮤지카드만 쿼리 (act가 true)
      const q = query(
        collection(db, "musicians"),
        where("act", "==", true)
      );
      const snapshot = await getDocs(q);
      // 전체 결과에서 searchTerm에 해당하는 이름을 필터링 (대소문자 무시)
      const results = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((card) =>
          card.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      setMusicards(results);
    } catch (error) {
      console.error("뮤지카드 검색 오류:", error);
    }
    setHasSearched(true);
    setIsLoading(false);
  };

  // 항목 선택 시 처리
  const handleSelect = async (card) => {
    try {
      // /musicians/[뮤지카드ID]/style/main 문서에서 sns 필드 가져오기
      const styleRef = doc(db, "musicians", card.id, "style", "main");
      const styleSnap = await getDoc(styleRef);
      const sns = styleSnap.exists() ? styleSnap.data().sns || {} : {};
      // /musicians/[뮤지카드ID] 문서에서 name과 positions 정보 가져오기
      const musicianRef = doc(db, "musicians", card.id);
      const musicianSnap = await getDoc(musicianRef);
      const name = musicianSnap.exists() ? musicianSnap.data().name || "" : "";
      const positions = musicianSnap.exists() ? musicianSnap.data().positions || {} : {};

      const result = {
        link: `https://musizic.com/musicard/${card.id}`,
        profileImage: card.profileImage || "",
        sns: sns,
        name: name,
        positions: positions
      };

      if (onSelect && typeof onSelect === "function") {
        onSelect(result);
      } else {
        navigate(`/my-page/members/${memberID}`, { state: { selectedSource: result } });
      }
    } catch (error) {
      console.error("뮤지카드 선택 오류:", error);
      alert("뮤지카드 정보를 가져오는 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className={styleClasses.skillSourceSelector}>
      <h1>뮤지카드 검색</h1>
      <div style={{ marginBottom: "1rem" }}>
        <input
          type="text"
          placeholder="뮤지카드 이름 검색..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ padding: "0.5rem", width: "100%" }}
        />
        <button onClick={handleSearch} style={{ marginTop: "0.5rem" }}>
          검색
        </button>
      </div>
      {isLoading && <Loading />}
      {hasSearched && (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
          {musicards.length > 0 ? (
            musicards.map((card) => (
              <div
                key={card.id}
                className={styleClasses.card}
                style={{
                  cursor: "pointer",
                  border: "1px solid #ccc",
                  padding: "0.5rem",
                  width: "120px"
                }}
                onClick={() => handleSelect(card)}
              >
                {card.profileImage ? (
                  <img
                    src={card.profileImage}
                    alt={card.name}
                    style={{ width: "100%", height: "auto" }}
                  />
                ) : (
                  <div style={{ width: "100%", height: "80px", backgroundColor: "#eee" }}>
                    이미지 없음
                  </div>
                )}
                <p>{card.name || "이름 없음"}</p>
              </div>
            ))
          ) : (
            <p>검색 결과가 없습니다.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default MusicardSelector;